"use client";

import type { EventName, TaxonomyEvent } from "@navikt/analytics-types";
import { getAnalyticsInstance } from "@navikt/nav-dekoratoren-moduler";
import { isLocalOrDemo } from "@/env-variables/envHelpers.ts";

const logger = getAnalyticsInstance("syfo-oppfolgingsplan-frontend");

export function logAnalyticsEvent<K extends EventName>(
  event: TaxonomyEvent<K>,
) {
  if (isLocalOrDemo) {
    console.log("Analytics event logged:", event);
    return;
  }

  logger(event.name, event.properties);
}
